import { useTranslation } from 'react-i18next';

import type { AlertFormInstanceProps } from '../alert-form-instance-props';
import { ApprovedLoginLocationsForm } from '../approved-login-locations-form/approved-login-locations-form';
import { CountryUserWhiteListForm } from '../country-user-white-list-form/country-user-white-list-form';
import { DeniedLoginLocationsForm } from '../denied-login-locations-form/denied-login-locations-form';

type AlertFormProps = AlertFormInstanceProps & { alertId: string };

export const AlertForm: React.FC<AlertFormProps> = ({
  alertId,
  ...alertFormInstanceProps
}) => {
  const { t } = useTranslation();

  switch (alertId) {
    case 's10_constants_cloud_services_approved_countries':
      return <ApprovedLoginLocationsForm {...alertFormInstanceProps} />;

    case 's10_constants_cloud_services_country_user_whitelist':
      return <CountryUserWhiteListForm {...alertFormInstanceProps} />;

    case 's10_constants_cloud_services_restricted_countries':
      return <DeniedLoginLocationsForm {...alertFormInstanceProps} />;

    default:
      return t('components:alertConfigurationRules.unsupportedAlertConfig', {
        alertId,
      });
  }
};
